import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Import components
import StandardHalfTileView from './StandardHalfTileView';
import SMHalfTileView from '../SMHalfTile/SMHalfTileView';
import SMImageTileView from '../SMImageTile/SMImageTileView';

// Import assets
import './doubleTile.scss';
import TwitterController from '../SMHalfTile/TwitterController';

class DoubleTileController extends React.Component {
  static determineTileType(type, props) {
    switch (type) {
      case 'twitter':
        return (<TwitterController {...props} />);
      case 'facebook':
        return (<SMHalfTileView {...props} />);
      case 'instagram':
        return (<SMImageTileView {...props} icon={'instagram'} />);
      case 'youtube':
        return (<SMImageTileView {...props} icon={'youtube'} />);
      case 'vimeo':
        return (<SMImageTileView {...props} icon={'vimeo'} />);
      default:
        return (<StandardHalfTileView {...props} />);
    }
  }

  render() {
    return (
      <div className={'m-tile m-tile--double'}>
        <div className="m-tile__flex-wrapper">
          {DoubleTileController.determineTileType(this.props.type, this.props)}
        </div>
        <div className="m-tile__flex-wrapper">
          {DoubleTileController.determineTileType(this.props.secondTile.type, this.props.secondTile)}
        </div>
      </div>
    );
  }
}

DoubleTileController.propTypes = {
  secondTile: PropTypes.shape({
    headline: PropTypes.string,
    subline: PropTypes.string,
    image: PropTypes.oneOfType([
      PropTypes.shape({
        xxl: PropTypes.string,
        xl: PropTypes.string,
        lg: PropTypes.string,
        md: PropTypes.string,
        sm: PropTypes.string,
        default: PropTypes.string,
      }), PropTypes.array,
    ]),
    type: PropTypes.string.isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    lang: state.globalsState.lang,
  };
}

export default connect(mapStateToProps)(DoubleTileController);



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/DoubleTile/DoubleTileController.jsx